import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-streamline-dianostic-qrcode-border",
  "use": "app-icon-streamline-dianostic-qrcode-border-usage",
  "viewBox": "0 0 224 224",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 224 224\" id=\"app-icon-streamline-dianostic-qrcode-border\"><g stroke=\"#6C92FA\" stroke-width=\"6\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M221 42.915V7a4 4 0 00-4-4h-35.361 0M3 181.085V217a4 4 0 004 4h35.361M221 181.085V217a4 4 0 01-4 4h-35.361 0M3 42.915V7a4 4 0 014-4h35.361\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol